export const UnreadIndicator = ({ count }: { count: number }) => {
  if (count > 0) {
    return (
      <div className="inline-flex min-h-4 min-w-4 rounded-full bg-[#2563EB] text-[#F7F9FA]">
        <span className="inline-block min-h-4 min-w-4 px-1.5 py-[1px] text-center text-[10px] font-semibold">
          {count}
        </span>
      </div>
    );
  }

  return null;
};
